import actions from "./actions";

const initState = {
    countries: [],
    readCountriesState: false,
    states: [],
    readStatesState: false,
    currencies: [],
    readCurrenciesState: false,
    msicCodes: [],
    readMsicCodesState: false,
};

export default function authReducer(state = initState, action = {}) {
    switch (action.type) {
        // countries
        case actions.PUBLIC_LIST_READ_COUNTRIES_REQUEST:
            return {
                ...state,
                readCountriesState: 'request',
            };
        case actions.PUBLIC_LIST_READ_COUNTRIES_SUCCESS:
            return {
                ...state,
                readCountriesState: 'success',
                countries: action.countries,
            };

        // states
        case actions.PUBLIC_LIST_READ_STATES_REQUEST:
            return {
                ...state,
                readStatesState: 'request',
            };
        case actions.PUBLIC_LIST_READ_STATES_SUCCESS:
            return {
                ...state,
                readStatesState: 'success',
                states: action.states,
            };

        // currencies
        case actions.PUBLIC_LIST_READ_CURRENCIES_REQUEST:
            return {
                ...state,
                readCurrenciesState: 'request',
            };
        case actions.PUBLIC_LIST_READ_CURRENCIES_SUCCESS:
            return {
                ...state,
                readCurrenciesState: 'success',
                currencies: action.currencies,
            };

        // msic codes
        case actions.PUBLIC_LIST_READ_MSIC_CODE_REQUEST:
            return {
                ...state,
                readMsicCodesState: 'request',
            };
        case actions.PUBLIC_LIST_READ_MSIC_CODE_SUCCESS:
            return {
                ...state,
                readMsicCodesState: 'success',
                msicCodes: action.msicCodes,
            };

        default:
            return state;
    }
}
